import styled from '@emotion/styled'

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[props.widthIndex]};
  margin: 0 auto;
  padding: 1rem 0 2rem 0;
`

const ChartContainer = ({ children, widthIndex = 1 }) => {
  return <StyledDiv widthIndex={widthIndex}>{children}</StyledDiv>
}

export default ChartContainer
